import EntityAddress from './EntityAddress'

export default EntityAddress
